import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import classNames from 'classnames';
import noCache from 'superagent-no-cache';
import T from 'i18n-react';

class ComponentLightboxVideoContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    }

  }

  componentDidUpdate() {
    if (!this.state.isLoading) this.props.keepFocus();
  }
  componentDidMount() {
  }

  render() {
    if (!this.props.fetchUrl) return false;
    let url = this.props.fetchUrl;
    let videoType = this.props.videoType;
    let embedUrl = '';

    switch (videoType) {
      case 'youtube':
        embedUrl = 'https://www.youtube.com/embed/' + url.substring(url.indexOf('=') + 1) + '?autoplay=1';
        break;
      case 'vimeo':
        embedUrl = 'https://player.vimeo.com/video/' + url.substring(url.lastIndexOf('/') + 1) + '?autoplay=1&byline=0&portrait=0';
        break;
      default:
    }
    let $lightbox = $('.remodal');
    $lightbox.addClass('video');
    $lightbox.parent().addClass('video-background');

    return (
      <div className="component-lightbox_wrapper_video">
        <header className="component-lightbox_header clearfix">
          <button type="button" data-remodal-action="close" className="component-lightbox_close" aria-label="Knapp, stäng fönster"></button>
        </header>
        <div className="component-lightbox_content">
          <div className="video-puff-wrapper">
            <iframe width="560" height="315" src={embedUrl} frameBorder="0" allowFullScreen={true}></iframe>
          </div>
        </div>
        <button type="button" data-remodal-action="close" className="goToFirstElm" aria-hidden="true"></button>
      </div>
    );
  }
};

export default ComponentLightboxVideoContent;
